export default __webpack_public_path__ + "static/media/sticker-i.f924ad65.png";